import '../src/styles/App.css';
import './i18n/i18n';
import '../src/styles/splide.css';

import { Box, useColorMode } from '@chakra-ui/react';
import Cookies from 'js-cookie';
import React, { useEffect, useMemo } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom';

import { BasicApi } from './api/basicApi';
import AgeCheckModal from './components/AgeCheck/AgeCheckModal';
import AnnouncementModal from './components/Announcement/components/AnnouncementModal';
import AudioPlayer from './components/AudioPlayer/AudioPlayer';
import LineCustomerModal from './components/LineCustomerModal/LineCustomerModal';
import LiveChat from './components/LiveChat/LiveChat';
import LoadingPage from './components/Loading/LoadingPage';
import LossPointModal from './components/LossPoint/LossPointModal';
import MaintainAlertModal from './components/MaintainAlertModal/MaintainAlertModal';
import ProgressBlock from './components/ProgressBlock/ProgressBlock';
import CommonHelmet from './components/Seo/commonHelmet';
import WalletSetting from './components/SignInUp/components/WalletSetting';
import { API_RELOAD } from './constant';
import useCheckLogin from './hook/useCheckLogin';
import useDeviceType from './hook/useDeviceType';
import DescriptionDashboard from './pages/Game/gameDescription/descriptionDashboard';
import StartGameButton from './pages/Home/StartGameButton';
import ColorModePage from './pages/Settings/components/colorModePage';
import LanguagePage from './pages/Settings/components/LanguagePage';
import GoogleNotification from './pages/Singin/components/GoogleNotification';
import StatusModal from './pages/StatusModal/StatusModal';
import EarnMoneyFromSocket from './pages/WebSocket/EarnMoneyFromSocket';
import ShouldHideMenu from './utils/hideMenu';
import OverflowHidden from './utils/OverflowHidden';
import { common_route, routes, rules_route } from './utils/routes';

//
function App() {
  const { i18n } = useTranslation();

  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.isTheme === 'dark');

  const navigate = useNavigate();
  const location = useLocation();

  const deviceType = useDeviceType();
  const hideMenu = ShouldHideMenu();

  const { lang } = useParams();

  const { isLogin, isMachineUser } = useCheckLogin();

  const locationChanger = useMemo(() => {
    if (location.pathname?.includes('profile')) {
      return false;
    } else {
      return location.key;
    }
  }, [location]);
  const [searchParams, setSearchParams] = useSearchParams();

  const token = searchParams.get('token');

  const { setColorMode } = useColorMode();
  useEffect(() => {
    setColorMode('dark');
  }, [setColorMode]);

  useEffect(() => {
    const className = 'dark';
    const bodyClasses = document.body.classList;

    isDarkMode ? bodyClasses.add(className) : bodyClasses.remove(className);
  }, [isDarkMode]);

  useEffect(() => {
    BasicApi(dispatch)();
    if (token) {
      Cookies.set('token', token, { expires: 365 });
    }
    dispatch({ type: 'INITIALIZE_API', navigate: navigate });
  }, []);

  const languagePop = useSelector((state) => state.isLanguagePop);
  const walletSettingPop = useSelector((state) => state.isWalletSettingPop);
  const comissionListPop = useSelector((state) => state.isComissionListPop);
  const colorTab = useSelector((state) => state.isColorMode);
  const isGameDescriptionConfig = useSelector(
    (state) => state.isGameDescriptionPop
  );

  useEffect(() => {
    const fetchDataPeriodically = () => {
      dispatch({ type: 'UPDATE_DATA_PERIODICALLY', navigate: navigate });
      // dispatch({ type: "CURRENCY_EXCHANGER" });
    };

    const apiIterval = setInterval(() => {
      fetchDataPeriodically();
    }, API_RELOAD);

    return () => clearInterval(apiIterval);
  }, []);

  const ROUTES = [...rules_route, ...routes];

  useEffect(() => {
    //記住代理邀請碼
    const searchParams = new URLSearchParams(location.search);
    const currentInviteParams = searchParams.get('invite');
    if (currentInviteParams) {
      Cookies.set('invite', currentInviteParams, { expires: 1 / 48 });
    }
  }, [location]);

  return (
    <ErrorBoundary fallback={<div>&nbsp;</div>}>
      <EarnMoneyFromSocket />
      <GoogleNotification />
      <CommonHelmet />
      <Box
        // bgImage={`url(${BG_MASK})`}
        // bgSize={`auto`}
        className={`${
          deviceType === 'PC'
            ? hideMenu
              ? ' w-full'
              : 'w-full pl-[320px]'
            : ''
        }`}
      >
        {/* <PageProgress key={locationChanger} /> */}

        <Routes location={location}>
          {ROUTES?.filter((route) => !route.hidden)?.map((route, index) => {
            return (
              <Route
                key={route.path}
                path={`${route.path}`}
                element={route.element}
              >
                {common_route
                  ?.filter((route) => !route.hidden)
                  ?.map((child, index) => {
                    return (
                      <Route
                        key={child.path}
                        exact={child.exact}
                        path={`${child.path}`}
                        element={
                          <OverflowHidden>
                            {child.element}
                            <Outlet key={child.path} />
                          </OverflowHidden>
                        }
                      >
                        {child.children?.map((item) => {
                          return (
                            <Route
                              exact={item.exact}
                              key={item.path}
                              path={`${item.path}`}
                              element={
                                <>
                                  {item.element}
                                  <Outlet />
                                </>
                              }
                            />
                          );
                        })}
                      </Route>
                    );
                  })}
              </Route>
            );
          })}
          <Route path="*" element={<Navigate to={`/`} />} />
        </Routes>
      </Box>
      {/* 未登入 且判斷是機台 顯示全螢幕半透明黑色背景 讓他按開始遊戲 */}
      {!isLogin && isMachineUser && <StartGameButton />}
      {!isMachineUser && <AgeCheckModal />}
      <ProgressBlock />
      {colorTab && <ColorModePage />}
      {languagePop && <LanguagePage />}
      {walletSettingPop && <WalletSetting />}
      {isGameDescriptionConfig?.state === true && <DescriptionDashboard />}
      <LoadingPage />
      {process.env.REACT_APP_LIVECHAT_OPEN == '1' ? <LiveChat /> : null}
      <StatusModal />
      <AudioPlayer />
      {/* 輸分已達到，不可充值彈窗 */}
      <LossPointModal />
      <LineCustomerModal />
      <MaintainAlertModal />
      <AnnouncementModal/>
    </ErrorBoundary>
  );
}

export default React.memo(App);
